import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle, XCircle, Drop, SpinnerGap } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const res = await api.paymentStatus(sessionId);
        if (res.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(res.payment_status)) return setState("failed");
      } catch (e) {}
      if (++tries < 8) setTimeout(poll, 1800); else setState("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-10 max-w-md w-full text-center fade-up">
        <div className="flex items-center justify-center mb-8">
          <img src="/adpw-logo.png" alt="All Day Power Washing" className="h-20 w-auto" />
        </div>
        {state === "checking" && (<><SpinnerGap size={56} className="mx-auto text-[#00B4D8] animate-spin" /><h1 className="font-display text-2xl font-bold mt-4 text-slate-900">Confirming payment…</h1><p className="text-slate-500 mt-2">Just a moment while we verify with Stripe.</p></>)}
        {state === "paid" && (<><CheckCircle size={64} weight="fill" className="mx-auto text-emerald-500" data-testid="payment-success-icon" /><h1 className="font-display text-2xl font-bold mt-4 text-slate-900">Payment Received!</h1><p className="text-slate-500 mt-2">Thank you. A receipt has been recorded. Your invoice is now marked paid.</p></>)}
        {state === "failed" && (<><XCircle size={64} weight="fill" className="mx-auto text-rose-500" /><h1 className="font-display text-2xl font-bold mt-4 text-slate-900">Payment not completed</h1><p className="text-slate-500 mt-2">We couldn't confirm your payment. Please try again from your invoice link.</p></>)}
        <Link to="/"><Button variant="outline" className="mt-8">Back to home</Button></Link>
      </div>
    </div>
  );
}
